import styled from '@emotion/styled';
import * as main from '@shared/styles/abstracts/vars.module.scss';
import { TextOverflow } from '@shared/ui/TextOverflow/index.tsx';

export const SDescription = styled.section`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  width: calc(100% - 100px);
`;

export const SName = styled(TextOverflow)`
  font-size: 18px;
  line-height: 20px;
  padding-right: 10px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;
export const SSpecialization = styled(TextOverflow)`
  font-size: 14px;
  line-height: 18px;
  //text-align: left;
  margin-top: 4px;
  white-space: nowrap;
  color: ${main.colorTextSecondary};
`;
